const app = require('loginApp');
const template = require('./passwordReset.hbs'),
    getLanguage = require('shared/helpers/getLanguage'),
    M = require('shared/messages/messages'),
    BaseView = require('base/saveItemView');
require('backbone.stickit');
require('backbone.validation');

module.exports = BaseView.extend({
    // This ensures that the div containing this view that gets inserted into the region has the proper class name.
    className: 'login-body-row',
    template: template,
    ui: {
        passwordResetForm: "#passwordResetForm"
    },
    behaviors: {
        WaitButton: {},
        LockForm: {},
        HandleServerValidationError: {}
    },
    events: {
        'submit @ui.passwordResetForm': 'onSubmitPasswordReset'
    },
    templateContext: {
        M: M,
    },
    initialize:function() {
        Backbone.Validation.bind(this);
    },
    onRender: function() {
        this.stickit();
    },
    onSubmitPasswordReset: function (e) {
        e.preventDefault();
        if (!this.model.isValid(true)) {
            return;
        }
        this.model.set('language', getLanguage());
        let promise = this.model.save();
        this.waitOn(promise, e);
        this.lockFormOn(promise);
        promise.done(function (result) {
            app.notifySuccess(M.resetPasswordSuccess());
            window.location.hash = 'login';
        }.bind(this));
        promise.fail(function (response) {
            if (this.hasServerValidationFailures(response)) {
                this.showServerValidationErrors(response);
                return;
            }
            app.notifyError('Your password reset code is incorrect or expired. Please try again.');
        }.bind(this));
    },
    bindings: {
        '#newPassword': 'newPassword',
        '#passwordConfirm': 'passwordConfirm'
    }
});
